<template>
  <a
    :href="href"
    :aria-label="'Download QR code as ' + type + ' ' + size"
    target="_blank"
    :download="filename"
    @click="download"
  >
    <slot />
    <QRCodeVue
      ref="domimg"
      class="d-none"
      :value="url"
      :size="modifiedSize"
      :render-as="renderAs"
    />
  </a>
</template>

<script>
import QRCodeVue from "qrcode.vue";

export default {
  components: { QRCodeVue },

  props: {
    url: {
      type: String,
      default: "",
    },

    type: {
      type: String,
      default: "png",
    },

    size: {
      type: String,
      default: "400",
    },
  },

  data: () => ({
    href: "#",
  }),

  computed: {
    filename() {
      const alias = this.url.slice(
        this.url.lastIndexOf("/") + 1,
        this.url.length,
      );

      return this.renderAs === "svg" ? alias : `${alias}-${this.size}`;
    },

    renderAs() {
      return this.type === "svg" ? "svg" : "canvas";
    },

    modifiedSize() {
      return this.size / 1.25;
    },
  },

  methods: {
    download(e) {
      // don't generate blob / object url / data url until needed
      // otherwise they can fill browser space in a way that wont be garbage collected
      if (this.renderAs === "svg") {
        const svg = this.$refs.domimg.$el.children[0];
        svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");

        const blob = new Blob([svg.outerHTML], { type: "image/svg+xml" });
        const url = window.URL.createObjectURL(blob);

        e.target.href = url;
        this.href = url;
      } else {
        const png = this.$refs.domimg.$el.children[0];
        const url = png.toDataURL();

        e.target.href = url;
        this.href = url;
      }
    },
  },
};
</script>
